/** @format */

import React from 'react';

/**
 * https://reacttraining.com/react-router/web/guides/scroll-restoration
 * IOS does not support scroll restoration on navigation. So we include this in places we always want to snap to the top on mount.
 */
class ScrollToTopOnMount extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return null;
    }
}

export default ScrollToTopOnMount;
